import React, { useEffect, useState } from 'react';
import { Avatar, Col, Form, Row, Space, Table } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import PersianDatePicker from '../../components/PersianDatePicker';
import ReportPageLayout from './ReportPageLayout';
import ReportFiltersCard from './ReportFiltersCard';
import { reportsApi } from '../../utils/api';
import { getLast30DaysRange } from '../../utils/dateUtils';
import { extractPagination, extractRows, getDateRangePickerValue, parseDateRangeChange } from './reportUtils';
import { TableSkeleton } from '../../components/SkeletonLoaders';

const LeaveReport = () => {
  const range = getLast30DaysRange('jYYYY-MM-DD', 'jalali');
  const [filters, setFilters] = useState({ startDate: range.startDate, endDate: range.endDate, page: 1, per_page: 15 });
  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 15, total: 0 });
  const [loading, setLoading] = useState(false);

  const load = async (next) => {
    if (!next.startDate || !next.endDate) return;
    setLoading(true);
    try {
      const res = await reportsApi.getLeaveReport(next);
      setRows(extractRows(res));
      setPagination(extractPagination(res));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => load(filters), 350);
    return () => clearTimeout(timer);
  }, [filters]);

  return (
    <ReportPageLayout
      headerIcon={<CalendarOutlined />}
      title="گزارش مرخصی"
      subtitle="خلاصه مرخصی کارکنان در بازه انتخابی"
    >
      <ReportFiltersCard>
        <Form layout="vertical" className="custom-font">
          <Row gutter={12}>
            <Col xs={24} md={12} lg={10}>
              <Form.Item label="بازه تاریخ" className="mb-0">
                <PersianDatePicker
                  range
                  placeholder="انتخاب بازه از تاریخ تا تاریخ"
                  value={getDateRangePickerValue(filters.startDate, filters.endDate)}
                  onChange={(dates) => setFilters((p) => ({ ...p, ...parseDateRangeChange(dates), page: 1 }))}
                  style={{ minHeight: 36 }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </ReportFiltersCard>

      {loading ? (
        <TableSkeleton rows={6} columns={6} />
      ) : (
        <Table
          rowKey={(r, i) => r.id || i}
          dataSource={rows}
          scroll={{ x: 900 }}
          className="custom-font"
          pagination={{
            ...pagination,
            onChange: (page, pageSize) => {
              const next = { ...filters, page, per_page: pageSize };
              setFilters(next);
            },
          }}
          columns={[
            {
              title: 'کارمند',
              render: (_, r) => (
                <Space>
                  <Avatar src={r?.image_url} size={36} />
                  <span>{r?.employee_name || r?.name || '-'}</span>
                </Space>
              ),
            },
            { title: 'سمت', dataIndex: 'designation_name' },
            { title: 'مرخصی تاییدشده', dataIndex: 'count_approved_leaves' },
            { title: 'مرخصی در انتظار', dataIndex: 'count_pending_leaves' },
            { title: 'موبایل', dataIndex: 'mobile_with_phonecode' },
          ]}
        />
      )}
    </ReportPageLayout>
  );
};

export default LeaveReport;
